<template>
  <div class="content">
    ola
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
  };
</script>
